import { Router } from "@frui.ts/screens";
import { Modules } from "config";
import { computed } from "mobx";
import LocalizationService from "services/localizationService";
import type CountrySelectViewModel from "../../../../countrySelectViewModel";
import TransferRefundsViewModel from "../transferRefundsViewModel";
import EventBus, { domesticTransferRefundUpdated } from "services/eventBus";
import { bound } from "@frui.ts/helpers/dist";
import RefundType from "entities/refundType";
import DomesticRefundDetailViewModel from "./domesticRefundDetailViewModel";
import RefundRepository from "repositories/refundRepository";
import OptionsService from "services/optionsService";
import RefundsApprovalService from "services/refundsApprovalService";
import TransferPaymentType from "entities/transferPaymentType";
import Selectable, { SelectableListViewModel } from "../../../../selectableListViewModel";
import type TransferRefund from "entities/transferRefundResponse";

const navigationName = "domestic";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
  children: [DomesticRefundDetailViewModel],
})
@Selectable
export default class DomesticRefundsViewModel extends TransferRefundsViewModel {
  readonly transferRefundType = TransferPaymentType.Domestic;
  readonly refundType = RefundType.DomesticTransfer;

  constructor(
    protected detailViewModelFactory: ReturnType<typeof DomesticRefundDetailViewModel.Factory>,
    protected localizationService: LocalizationService,
    protected eventBus: EventBus,
    protected approvalService: RefundsApprovalService,
    protected optionsService: OptionsService,
    protected repository: RefundRepository,
    protected countrySelectViewModelFactory: ReturnType<typeof CountrySelectViewModel.Factory>
  ) {
    super(
      detailViewModelFactory,
      localizationService,
      eventBus,
      approvalService,
      optionsService,
      repository,
      countrySelectViewModelFactory
    );
    this.navigationName = navigationName;
  }

  @computed
  get self(): SelectableListViewModel<DomesticRefundsViewModel, TransferRefund> {
    return this as any;
  }

  protected processData(items: TransferRefund[]) {
    items.forEach(item => {
      item.isSelectable =
        item.permittedActions.approval.isAllowed && (this.canApprove(item) || false) && this.myApprovalStep(item);

      return item;
    });

    return items;
  }

  @bound
  onInitialize() {
    this.unsubscriptions.push(this.eventBus.subscribe(domesticTransferRefundUpdated, this.loadData));
    return super.onInitialize();
  }

  @bound
  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.finance, `refundApprovals.domestic.${code}`, size);
  }
}
